import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'

export default {
    name: 'story_question',
    props: {
        question : Object,
        story : Object
    },

    data : function(){

        return {
            loading : false,
            emojiIndex : 0,
            emoji : [
                "🎈","🎉","🥳","🎊","🎀","🎁","🎎","🎏","🎐",
                "🎇","🎆","🎭","🎨","🖍️","🧩","🧸","🪀",
                "🪁","🏮","🪔","✨","⭐","🌟","💫","💎","🔮",
                "🎶","🎵","🎼","📯","🥁","🎺","🎷","🎸","🎻","🎹",
                "🎲","🧿","⚽","🏀","🏐","🏓","🥏","🎳",
            ],

            focusAnswer : -1

        }

    },

    created () {
        this.emojiIndex = f.rand(0, this.emoji.length - 1)
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        noimagesinstory : state => state.noimagesinstory,
        currentEmoji : function(){
            return this.emoji[this.emojiIndex]
        },
        noimagesinstory : state => state.noimagesinstory,

        image : function(){
            var si = _.filter(this.story.scenes, (s) => {
                return s.image
            })

            if(si.length){
                var index = f.rand(0, si.length - 1)

                return si[index].image
            }

            return null

            
        }
    }),

    methods : {
        setAnswer : function(index, e){

            if(this.focusAnswer > -1) return

            var right = this.question.answers[index] == this.question.answer

            this.focusAnswer = index


            if(right){
                this.starsEffect(e)

                setTimeout(() => {
                    this.focusAnswer = -1

                    this.$emit('answer', {
                        question : this.question,
                        answer : this.question.answers[index]
                    })
                    
                }, 600)

                
            }
            else{
                setTimeout(() => {
                    this.focusAnswer = -1
                }, 700)
            }
        },

        /*rightAnswer : function(){
            
        },*/

        starsEffect : function(event, p = {}){

            if(this.noimagesinstory) return

            if (this.core.infinityEffect){
                this.core.infinityEffect.play('stars', {
                    size : 15,
                    scatter : 100,
                    opacity : 0.8,
                    color : '#ffa000',
                    
                    from : {
                        y : 'random',
                        x : 'random'
                    },

                    to : {
                        y : event.screenY,
                        x : event.screenX
                    },

                    count : f.rand(60, 120),
                    ...p
                })
            }
        },
    },
}